// extracted by mini-css-extract-plugin
export default {"freeButNotFree":"freeButNotFree_L_V4x","wrapper":"wrapper_WliU8","block":"block_UKQE5"};